import { RippleGlobalOptions } from '@angular/material';
import 'hammerjs';
var globalRippleConfig = {
    disabled: true,
    animation: {
        enterDuration: 0,
        exitDuration: 0
    }
};
var ɵ0 = { duration: 3000 }, ɵ1 = globalRippleConfig;
var MaterialModule = /** @class */ (function () {
    function MaterialModule() {
    }
    return MaterialModule;
}());
export { MaterialModule };
export { ɵ0, ɵ1 };
